// On-pickup draw pure helper. No React, no Three.js.
//
// ── Codex (13 Treasures of Britain, Artifact. Relic) ──
//   "When picked up, bearer's controller draws a card. Teleport the
//    Treasures to the top of a random site or void."
//
// on_pickup trigger. Fires the moment the Relic becomes carried
// (equipped onto a Minion or Avatar). This op resolves the first half:
// the bearer's controller draws args.amount spells through the unified
// host.drawCard funnel. The random-destination teleport half is not
// wired (see DEFER note in the schema / deliverable).
//
// The firing controller is the bearer's controller, threaded in from
// the equip choke point via opts.controller and forwarded here as
// `controller`.
//
// Host adapter contract (already on host._silentOpsHost):
//   drawSpellsFor(controller, count): number. Draws `count` spells
//     into `controller`'s hand; returns how many were drawn.
//   logAction(key, values?): void

import { msg } from '../../../logMessage';

/**
 * Resolve 13 Treasures of Britain's on-pickup draw.
 *
 * @param {object} sourceCard
 * @param {object} args        { amount?, source?: 'spell' | 'site' | 'card' }
 * @param {object} host
 * @param {string} controller  the bearer's controller ('p1' | 'p2')
 */
export function applyDrawForBearer(sourceCard, args, host, controller) {
  if (!controller) return;
  const count = args?.amount ?? 1;
  const drawn = host.drawSpellsFor(controller, count, args?.source);
  if (drawn > 0) {
    host.logAction('{source}: {who} draws {n} on pickup', {
      source: sourceCard.name || msg('Relic'),
      who: controller === 'p1' ? msg('Player 1') : msg('Player 2'),
      n: drawn,
    });
  }
}
